import { LoggedInUserFragmentFragment } from 'data/__generated__';
import { createContext } from 'react';

export const UserContext = createContext<LoggedInUserFragmentFragment>({} as LoggedInUserFragmentFragment);
